import TabComponent from 'components/_parts/atoms/tab/Wla';
import { TabComponentTypes } from 'components/types/company';
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import ActivityType from 'components/company/revamp/parts/setting/activity/list';
import Fte from 'components/company/revamp/parts/setting/fte/list';
import WorkerType from 'components/company/revamp/parts/setting/workerType/list';
import Classification from 'components/company/revamp/parts/setting/customWla/list';
import { useTranslation } from 'react-i18next';
import CategoryGroup from 'components/company/revamp/parts/setting/customCategory/list';
import { TabWLA } from '../dummySetting';
import { useFetchWLAGroup } from './useFetch';

const CustomTabWLA = styled(TabComponent)`
  justify-content: flex-start !important;
  overflow: auto;

  scrollbar-width: thin;
  &::-webkit-scrollbar {
    height: 4px; 
  }
`;

function Workload() {
  const { t } = useTranslation();
  const dataTab = TabWLA();
  const [tab, setTab] = useState(1);
  useFetchWLAGroup(tab);
  const handleTab = (val: TabComponentTypes) => {
    setTab(val.id);
  };

  const memoContent = useMemo(() => {
    switch (tab) {
      case 1:
        return <CategoryGroup t={t} />;
      case 2:
        return <Classification t={t} />;
      case 3:
        return <ActivityType t={t} />;
      case 4:
        return <Fte t={t} />;
      case 5:
        return <WorkerType t={t} />;

      default:
        return <CategoryGroup t={t} />;
    }
  }, [tab]);

  return (
    <>
      <CustomTabWLA
        tab={tab}
        dataTab={dataTab}
        handleClickTab={handleTab}
      />
      <div className="tw-mt-[12px]">
        {memoContent}
      </div>
    </>
  );
}

export default Workload;
